var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import { dateTimeFormat, getAllGames, gameNameFixer, loadingAnimation, ServerDate, slugify } from "../../services/misc.functions";
import { OrderHistoryMenu } from "./account";
import { useNavigate, useParams } from "react-router";
import { isMobile } from "../../App";
import paths from "../../paths";
// NOT: Eskiden tanımlanmış typeların devamlılığı için bırakıldı.
var gameTypes = {
    esyapiyangosu: {
        name: "Eşya Piyangosu",
        type: 5,
        code: "esyapiyangosu",
    },
    puankazan: {
        name: "Oyna Kazan",
        type: 7,
        code: "kazi_kazan",
    },
    supertombala: {
        name: "Süper Tombala",
        type: 12,
        code: "super_tombala",
    },
    zeplin: {
        name: "Zeplin",
        type: 15,
        code: "zeplin",
    },
    atestoplari: {
        name: "Ateş Topları",
        type: 23,
        code: "9044",
    },
    carkifelek: {
        name: "Çarkıfelek",
        type: 20,
        code: "carkifelek",
    },
    meyvekulesi: {
        name: "Meyve Kulesi",
        type: 18,
        code: "9053",
    },
    taskagitmakas: {
        name: "Taş Kağıt Makas",
        type: 26,
        code: "taskagitmakas",
    },
    galaksituru: {
        name: "Galaksi Turu",
        type: 28,
        code: "9037",
    },
    isiltilitaslar: {
        name: "Işıltılı Taşlar",
        type: 30,
        code: "9050",
    },
    superplinko: {
        name: "Süper Plinko",
        type: 32,
        code: "9047",
    },
    kunduzunmacerasi: {
        name: "Kunduzun Macerası",
        type: 34,
        code: "9043",
    },
};
var getGameSlugs = function () { return __awaiter(void 0, void 0, void 0, function () {
    var games, gameSlugs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getAllGames()];
            case 1:
                games = _a.sent();
                gameSlugs = [];
                gameSlugs.push({
                    name: "Eşya Piyangosu",
                    slug: "esyapiyangosu",
                    type: 5,
                    code: "esyapiyangosu",
                });
                gameSlugs.push.apply(gameSlugs, games.map(function (game) {
                    var hasType = Object.values(gameTypes).find(function (type) { return type.code === game.code; });
                    return {
                        name: gameNameFixer(game.name),
                        slug: slugify(game.name
                            .toLowerCase()
                            .replaceAll("ü", "u")
                            .replaceAll("ş", "s")
                            .replaceAll("ç", "c")
                            .replaceAll("ğ", "g")
                            .replaceAll("ı", "i")
                            .replaceAll("ö", "o")),
                        type: hasType ? hasType.type : game.type,
                        code: game.code,
                    };
                }));
                return [2 /*return*/, gameSlugs];
        }
    });
}); };
export function AccountOrderHistory() {
    var _this = this;
    var _a;
    var _b = useState([]), gameSlugs = _b[0], setGameSlugs = _b[1];
    useEffect(function () {
        getGameSlugs().then(function (res) {
            setGameSlugs(res);
        });
    }, []);
    var params = useParams();
    var _c = useState(null), dataList = _c[0], setDataList = _c[1];
    var _d = useState(0), page = _d[0], setPage = _d[1];
    var navigate = useNavigate();
    var today = ServerDate();
    var _e = useState({
        start_date: today.toISOString().slice(0, 10) + "T00:00:00",
        end_date: today.toISOString().slice(0, 10) + "T23:59:59",
    }), filter = _e[0], setFilter = _e[1];
    useEffect(function () {
        setPage(0);
        loadData(0);
    }, [params === null || params === void 0 ? void 0 : params.id, filter]);
    var loadData = function (forcePage) {
        if (forcePage === void 0) { forcePage = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var pageN, payload, pathname;
            var _a, _b;
            return __generator(this, function (_c) {
                loadingAnimation(true);
                pageN = forcePage !== null ? forcePage : page;
                if (pageN === 0 && dataList && dataList.length > 0) {
                    setDataList([]);
                }
                payload = {
                    page: pageN,
                    game_code: (_a = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _a === void 0 ? void 0 : _a.code,
                    game_type: (_b = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _b === void 0 ? void 0 : _b.type,
                };
                if (filter) {
                    payload["create_date_from"] = filter["start_date"];
                    payload["create_date_to"] = filter["end_date"];
                }
                pathname = window.location.pathname;
                api
                    .start("post", env.accounting_api +
                    (pathname.includes("esyapiyangosu") || pathname.includes("puankazan")
                        ? "/somos/api/list-coupon/"
                        : "/games/api/list-coupon/"), payload, true)
                    .then(function (res) {
                    loadingAnimation(false);
                    var tmp = [];
                    if (res && res.status) {
                        if (pageN === 0 && dataList && dataList.length > 0) {
                            dataList.splice(0, dataList.length);
                            tmp.push.apply(tmp, res.data);
                        }
                        else {
                            if (dataList === null) {
                                tmp.push.apply(tmp, res.data);
                            }
                            else {
                                tmp = __spreadArray([], dataList, true);
                                tmp.push.apply(tmp, res.data);
                            }
                        }
                        if (res && res.metadata) {
                            var id_datalist_loadmore = document.getElementById("id_datalist_loadmore");
                            if (res.metadata.count === 0 || res.metadata.count <= tmp.length) {
                                id_datalist_loadmore.style.display = "none";
                            }
                            else {
                                id_datalist_loadmore.style.display = "unset";
                            }
                        }
                        setDataList(tmp);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    var loadMore = function (e) {
        e.target.disabled = true;
        var nPage = page + 1;
        setPage(nPage);
        loadData(nPage).finally(function () {
            e.target.disabled = false;
        });
    };
    var _f = useForm(), register = _f.register, handleSubmit = _f.handleSubmit, reset = _f.reset, errors = _f.formState.errors;
    var onSubmit = function (data) {
        var startDate = new Date(today);
        startDate.setDate(startDate.getDate() - Number(data.date));
        setPage(0);
        setDataList([]);
        var _filter = {
            start_date: startDate.toISOString().slice(0, 10) + "T00:00:00",
        };
        if (Number(data.date) == 0 || Number(data.date) == 1) {
            _filter.end_date = startDate.toISOString().slice(0, 10) + "T23:59:59";
        }
        setFilter(_filter);
    };
    if (!(params === null || params === void 0 ? void 0 : params.id) || !gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) {
        setTimeout(function () {
            navigate(paths.account.url + "/islem-gecmisim/esyapiyangosu/");
        }, 1000);
        return _jsx(_Fragment, {});
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsxs("div", __assign({ className: "col-3 col-mobile-12" }, { children: [_jsxs("div", __assign({ className: "card rounded-4 mb-2" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: "Filtrele" }) })), _jsx("div", __assign({ className: "card-body" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx("div", __assign({ className: "row mb-2" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsxs("select", __assign({ className: "form-control" }, register("date"), { children: [_jsx("option", __assign({ value: 7 }, { children: "Son 1 Hafta" })), _jsx("option", __assign({ value: 0, selected: true }, { children: "Bug\u00FCn" })), _jsx("option", __assign({ value: 1 }, { children: "D\u00FCn" })), _jsx("option", __assign({ value: 30 }, { children: "Son 30 G\u00FCn" }))] })) })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("button", __assign({ className: "btn w-100 btn-primary" }, { children: "G\u00F6ster" })) })) }))] })) }))] })), _jsx(OrderHistoryMenu, { gameSlugs: gameSlugs })] })), _jsx("div", __assign({ className: "col-9 col-mobile-12" }, { children: _jsxs("div", __assign({ className: "card rounded-4 mb-4" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsxs("h2", { children: ["\u0130\u015Flem Ge\u00E7mi\u015Fim - ", (_a = gameSlugs.find(function (game) { return game.slug === (params === null || params === void 0 ? void 0 : params.id); })) === null || _a === void 0 ? void 0 : _a.name] }) })), _jsxs("div", __assign({ className: "card-body mobile-scroll" }, { children: [dataList && dataList.length > 0 && (_jsxs("table", __assign({ className: "table table-hover table-striped" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ style: { width: 160 } }, { children: "Tarih" })), _jsx("th", __assign({ style: { width: 100 } }, { children: "\u00C7ekili\u015F" })), _jsx("th", __assign({ className: "text-center" }, { children: "Adet" })), _jsx("th", __assign({ className: "text-center" }, { children: "Tutar" })), _jsx("th", __assign({ className: "text-center" }, { children: "Kazan\u00E7" }))] }) }), _jsx("tbody", { children: dataList.map(function (item, key) {
                                                    return (_jsxs("tr", { children: [_jsxs("td", { children: [item.transaction_date
                                                                        ? !isMobile
                                                                            ? dateTimeFormat(item.transaction_date)
                                                                            : dateTimeFormat(item.transaction_date)
                                                                                .split(" ")
                                                                                .map(function (part, index) { return _jsx("div", { children: part }, index); })
                                                                        : "", item.approve_date
                                                                        ? !isMobile
                                                                            ? dateTimeFormat(item.approve_date)
                                                                            : dateTimeFormat(item.approve_date)
                                                                                .split(" ")
                                                                                .map(function (part, index) { return _jsx("div", { children: part }, index); })
                                                                        : ""] }), _jsx("td", { children: _jsx("span", __assign({ className: "d-block nowrap fw-bold" }, { children: item.draw__title_abbreviated })) }), _jsxs("td", __assign({ className: "text-center" }, { children: [item.count, " ", _jsx("br", {}), " bilet"] })), _jsxs("td", __assign({ className: "text-center" }, { children: [Number(item.total_tl_cost) > 0 ? (_jsxs("span", __assign({ className: "d-block" }, { children: [item.total_tl_cost, " ", _jsx("br", {}), " \u20BA"] }))) : (_jsx(_Fragment, {})), Number(item.total_point_cost) > 0 ? (_jsxs("span", __assign({ className: "d-block" }, { children: [item.total_point_cost, " ", _jsx("br", {}), " \u015EP"] }))) : (_jsx(_Fragment, {}))] })), _jsx("td", __assign({ className: "text-center" }, { children: Number(item.total_won_amount) > 0 ? (_jsxs(_Fragment, { children: [item.total_won_amount, " ", _jsx("br", {}), " \u015EP"] })) : ("-") }))] }, "support-ticket-list-".concat(key)));
                                                }) })] }))), dataList && dataList.length === 0 && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "text-center py-5" }, { children: "Listede kay\u0131t bulunmuyor." })) })), _jsxs("div", __assign({ className: "text-center" }, { children: [_jsx("div", { id: "id_loaderAnimation", className: "loader" }), _jsx("button", __assign({ id: "id_datalist_loadmore", onClick: loadMore, type: "button", className: "btn rounded-pill btn-outline-primary" }, { children: "Devam\u0131n\u0131 Y\u00FCkle" }))] }))] }))] })) }))] })) }));
}
